import {
  $applyNodeReplacement,
  DOMConversionMap,
  DOMConversionOutput,
  ParagraphNode,
} from 'lexical';

export class CasDivNode extends ParagraphNode {
  static getType(): string {
    return 'div';
  }

  static clone(node: CasDivNode): CasDivNode {
    return new CasDivNode(node.__key);
  }

  createDOM(): HTMLElement {
    return document.createElement('div');
  }

  updateDOM(): boolean {
    return false;
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: () => ({
        conversion: (element: HTMLElement): DOMConversionOutput => {
          if (
            element.childNodes.length === 0 ||
            (element.childNodes.length === 1 && element.childNodes[0].nodeName === 'BR')
          ) {
            const emptyDivNode = $createCasDivNode();
            return { node: emptyDivNode };
          }
          return { node: null };
        },
      }),
    };
  }
}

export function $createCasDivNode(): CasDivNode {
  return $applyNodeReplacement(new CasDivNode());
}
